import type { Dispatch } from 'react';
import { ApiV2 } from 'src/api/apiv2';
import { HEADERS } from 'src/constants/headers';
import type { TAPIOptions } from 'src/constants/apis/types';
import { handleError } from 'src/contexts/utils/handleError';
import { SET_LOADING } from 'src/contexts/types';
import { GET_CONTACTS } from '../constants/actions';
import type { TContactActionTypes } from '../types';
import type { IContact } from 'src/interfaces/contact';

export const searchContactsByFilters = async (
    dispatch: Dispatch<TContactActionTypes>,
    filters: Record<string, unknown>,
    options: TAPIOptions = {
        isReadPermissionNecessary: false,
        select: '',
        populate: [],
    }
): Promise<void> => {
    dispatch({ type: SET_LOADING, field: 'loadingContactList' });

    try {
        const payload = { ...filters };
        const res = await ApiV2.post(
            '/contacts/search',
            payload,
            HEADERS({
                isReadPermissionNecessary:
                    options.isReadPermissionNecessary ?? false,
            })
        );

        const results: IContact[] = res.data?.results ?? [];
        const total = res.data?.pagination?.total ?? 0;

        dispatch({
            type: GET_CONTACTS,
            payload: { contacts: results, total },
        });
    } catch (error) {
        dispatch({
            type: GET_CONTACTS,
            payload: { contacts: [], total: 0 },
        });

        if (error instanceof Error) dispatch(handleError(error));
    }
};
